var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconAssetsRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12.2 13.53 26.3 22.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF0066",
    d: "M36.856,13.542h-23c-0.896,0-1.625,0.729-1.625,1.625V34c0,0.896,0.729,1.625,1.625,1.625h23 c0.896,0,1.625-0.729,1.625-1.625V15.167C38.481,14.271,37.753,13.542,36.856,13.542z M37.231,15.167v2.134h-3.75v-2.509h3.375 C37.063,14.792,37.231,14.96,37.231,15.167z M22.231,31.866v2.509h-3.75v-2.509H22.231z M23.481,31.866h3.75v2.509h-3.75V31.866z  M28.481,31.866h3.75v2.509h-3.75V31.866z M13.481,30.616V18.551h23.75v12.065H13.481z M28.481,17.301v-2.509h3.75v2.509H28.481z  M27.231,17.301h-3.75v-2.509h3.75V17.301z M22.231,17.301h-3.75v-2.509h3.75V17.301z M13.856,14.792h3.375v2.509h-3.75v-2.134 C13.481,14.96,13.649,14.792,13.856,14.792z M13.481,34v-2.134h3.75v2.509h-3.375C13.649,34.375,13.481,34.207,13.481,34z  M36.856,34.375h-3.375v-2.509h3.75V34C37.231,34.207,37.063,34.375,36.856,34.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0066",
    d: "M27.742,23.668l-3.007-2.15c-0.345-0.247-0.793-0.279-1.169-0.085c-0.377,0.194-0.61,0.577-0.61,1v4.301 c0,0.424,0.233,0.807,0.61,1.001c0.163,0.084,0.34,0.125,0.516,0.125c0.229,0,0.458-0.071,0.653-0.21l3.007-2.15 c0.295-0.211,0.472-0.553,0.472-0.916C28.214,24.221,28.037,23.879,27.742,23.668z M24.206,26.491v-3.815l2.667,1.907 L24.206,26.491z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    d: " M36.856,35h-23c-0.552,0-1-0.448-1-1V15.167c0-0.552,0.448-1,1-1h23c0.552,0,1,0.448,1,1V34C37.856,34.552,37.409,35,36.856,35z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 12.856,
    y1: 17.926,
    x2: 37.856,
    y2: 17.926
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 12.856,
    y1: 31.241,
    x2: 37.856,
    y2: 31.241
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 17.856,
    y1: 14.167,
    x2: 17.856,
    y2: 17.926
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 22.856,
    y1: 14.167,
    x2: 22.856,
    y2: 17.926
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 27.856,
    y1: 14.167,
    x2: 27.856,
    y2: 17.926
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 32.856,
    y1: 14.167,
    x2: 32.856,
    y2: 17.926
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 17.856,
    y1: 31.241,
    x2: 17.856,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 22.856,
    y1: 31.241,
    x2: 22.856,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 27.856,
    y1: 31.241,
    x2: 27.856,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 32.856,
    y1: 31.241,
    x2: 32.856,
    y2: 35
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#FF0066",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    d: " M27.379,24.177l-3.007-2.15c-0.331-0.237-0.791,0-0.791,0.407v4.301c0,0.407,0.46,0.643,0.791,0.407l3.007-2.15 C27.658,24.791,27.658,24.376,27.379,24.177z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconAssetsRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-assets-red.038adf44.svg";
export { ForwardRef as ReactComponent };